import { SourceTypeConfigHelper } from '../../create-pipeline/components/source-settings-form/config-helper';

export class ShopifyConfigHelper implements SourceTypeConfigHelper {
  getConfigFromRawData(rawData: any) {
    return {
      shopName: rawData.shop_name,
      appPassword: rawData.app_password,
      clientId: rawData.client_id,
      clientSecret: rawData.client_secret,
      oauthTokenId: rawData.oauth_token_id
    };
  }

  getDefaultConfig() {
  }

  buildConnectionParams(data: any) {
    const useNewAuthFlow = !data.sourceVersion || data.sourceVersion > 10;
    const params: any = {
      shop_name: data.shopName
    };

    if (!useNewAuthFlow) {
      params.app_password = data.appPassword;
      return params;
    }

    if (useNewAuthFlow) {
      if (data.clientId) {
        params.client_id = data.clientId;
      }
      if (data.clientSecret) {
        params.client_secret = data.clientSecret;
      }

      if (data.oauthTokenId) {
        params.oauth_token_id = data.oauthTokenId;
      }
    }

    return params;
  }
}
